import React, { useRef, useEffect, useState } from 'react';
import { gsap } from 'gsap';
import html2canvas from 'html2canvas';
import styles from './button.module.scss';

interface ButtonProps {
  onExplode: (data: Uint8ClampedArray, w: number, h: number, targetBtn: HTMLButtonElement) => void;
}

interface PrecomputedData {
  data: Uint8ClampedArray;
  width: number;
  height: number;
}

export const Button: React.FC<ButtonProps> = ({ onExplode }) => {
  const btnRef = useRef<HTMLButtonElement>(null);

  const precomputedData = useRef<PrecomputedData | null>(null);

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const prepareSnapshot = async () => {
      const element = btnRef.current;
      if (!element) return;

      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(element, {
        backgroundColor: null,
        scale: 1,
        logging: false,
        useCORS: true,
      });

      const ctx = canvas.getContext('2d');
      if (ctx) {
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        precomputedData.current = {
          data: imageData.data,
          width: canvas.width,
          height: canvas.height,
        };
        setIsReady(true);
      }
    };

    prepareSnapshot();
  }, []);

  const handleClick = () => {
    const element = btnRef.current;

    if (!element || !precomputedData.current) return;

    const { data, width, height } = precomputedData.current;

    gsap.to(element, {
      scale: 1.05,
      duration: 0.1,
      ease: "power2.out",
      opacity: 0.7,
      onComplete: () => {
        onExplode(data, width, height, element);
      }
    });
  };

  return (
    <button
      ref={btnRef}
      className={styles.magicButton}
      onClick={handleClick}
      style={{
        opacity: isReady ? 1 : 0.5,
        cursor: isReady ? 'pointer' : 'wait'
      }}
      disabled={!isReady}
    >
      Delete Me
    </button>
  );
};